import React from 'react';
import type { IconProps } from '../../types';

// interface CallIconProps {
//   className?: string;
//   width?: number | string;
//   height?: number | string;
//   fill?: string;
// }

export const CallIcon: React.FC<IconProps> = ({
  className = '',
  width = 22,
  height = 22,
  fill = 'currentColor',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M12.25 0V1.5C16.7988 1.5 20.5 5.20125 20.5 9.75H22C22 4.374 17.626 0 12.25 0ZM4.48779 2.25439C4.09413 2.25439 3.70083 2.38283 3.38037 2.64111L3.34375 2.67041L0.985354 5.10352L1.03516 5.05664C0.254683 5.72881 0.03959 6.79059 0.374514 7.68311C1.00651 9.50556 2.61764 13.0297 5.7959 16.2041C8.98096 19.393 12.5421 20.9351 14.3037 21.6226L14.3213 21.6284L14.3389 21.6343C15.2497 21.9396 16.2336 21.7218 16.939 21.1187L16.9609 21.0996L19.3047 18.7559C19.9268 18.1337 19.9268 17.043 19.3047 16.4209L16.2314 13.3447C15.6075 12.7208 14.5175 12.7208 13.8936 13.3447L12.4053 14.833C11.8725 14.5787 10.5616 13.919 9.31592 12.731C8.08644 11.5585 7.45877 10.2033 7.23145 9.67969L8.73145 8.17969C9.38964 7.52149 9.42709 6.39146 8.66846 5.7876L8.73731 5.85059L5.63037 2.67041L5.59522 2.64111C5.27476 2.38285 4.88146 2.25439 4.48779 2.25439ZM12.25 3V4.5C15.1443 4.5 17.5 6.855 17.5 9.75H19C19 6.0285 15.9723 3 12.25 3ZM4.48926 3.75C4.54271 3.74991 4.59543 3.77005 4.64746 3.81006L7.69727 6.93311L7.73389 6.9624C7.72526 6.95554 7.76271 7.02734 7.6709 7.11914L5.45313 9.33691L5.62451 9.78955C5.62451 9.78955 6.471 12.0911 8.28028 13.8164C10.0594 15.5132 12.2529 16.4399 12.2529 16.4399L12.7202 16.6392L14.9541 14.4053C15.0802 14.2792 15.0448 14.2792 15.1709 14.4053L18.2441 17.4814C18.372 17.6093 18.372 17.5674 18.2441 17.6953L15.959 19.9805C15.611 20.2762 15.2515 20.3537 14.8193 20.2104C13.1227 19.547 9.80445 18.0952 6.85645 15.1436C3.88799 12.1787 2.3498 8.80995 1.78516 7.17773L1.78223 7.16895L1.77783 7.15869C1.66427 6.85836 1.74728 6.42279 2.01367 6.19336L2.03858 6.17139L4.32959 3.81006C4.38164 3.77042 4.43581 3.75009 4.48926 3.75ZM12.25 6V7.5C13.4905 7.5 14.5 8.5095 14.5 9.75H16C16 7.68225 14.3178 6 12.25 6Z'
        fill={fill}
      />
    </svg>
  );
};
